import { render, staticRenderFns } from "./adesoesPendentes.vue?vue&type=template&id=5b26e3dc"
import script from "./adesoesPendentes.vue?vue&type=script&lang=js"
export * from "./adesoesPendentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports